import definition from '@client/config/definition';
import { customLapKeyMap } from '@client/pages/activity-detail/config/sport.config';
import { sportColumnKeys } from './sport-column';

export const getSportColumnKeys = function (topSummary, summary) {
  const { sportName } = summary.value;
  const isCustomSport = definition.isCustomSport(topSummary.value.sportType);
  // console.log(`🔔 isCustomSport`, isCustomSport);
  if (isCustomSport) {
    const customKey = getCustomSportKeys(isCustomSport, topSummary.value);
    sportColumnKeys.Custom_Sport = customKey;
  }

  const columnKeys = sportColumnKeys[sportName];
  // if (!columnKeys.find((item) => item.key === 'uniqueId')) {
  //   columnKeys.splice(1, 0, { key: 'uniqueId', config: { status: true } });
  // }
  return columnKeys;
};
export function getCustomSportKeys(isCustomSport, summary) {
  const { customDataTypeList = [], customDataDsMultiplexList = [] } = summary;
  if (!isCustomSport) {
    return [];
  }

  const arr = [];
  customDataTypeList.forEach((dataType) => {
    const child = customLapKeyMap[dataType];
    if (child) {
      child.forEach((item) => {
        const { dsMultiplex } = item;
        if (dsMultiplex) {
          // 匹配复合条件
          if (customDataDsMultiplexList.includes(dsMultiplex)) arr.push(item);
        } else {
          arr.push(item);
        }
      });
    }
  });

  // 根据order排序
  arr.sort((a, b) => {
    return a.order - b.order;
  });
  // 提取数据
  let keys = [
    {
      key: 'Left_Gap',
      config: { status: true }
    }
  ];
  arr.forEach((item) => {
    const { config, order } = item;
    item.keys.forEach((key) => {
      keys.push({
        key,
        config,
        order
      });
    });
  });
  keys = Array.from(new Set(keys));
  return keys;
}
